import { http } from '@/shared/api/axios'
import type { PaginatedResponse } from '@shared/api/types'
import type { MyInvitation, GetMyInvitationsRequest } from '../model/types'

/**
 * Get the current user's invitations across all accounts.
 */
export const fetchMyInvitations = async (
  params: GetMyInvitationsRequest = { status: 'Pending', pageNumber: 1, pageSize: 20 }
): Promise<PaginatedResponse<MyInvitation>> => {
  const response = await http.get<PaginatedResponse<MyInvitation>>('/v1/me/invitations', { params })
  return response.data
}

export interface AcceptFulfillment {
  requiredCredentialId: number
  employeeCredentialId: number
}

/**
 * Accept a pending invitation, optionally linking provided credentials to the joined account.
 */
export const acceptInvitation = async (
  id: number,
  fulfillments: AcceptFulfillment[] = []
): Promise<void> => {
  await http.post(
    `/v1/me/invitations/${id}/accept`,
    { fulfillments },
    { _skipErrorToast: true } as never
  )
}

/**
 * Decline a pending invitation.
 */
export const declineInvitation = async (id: number): Promise<void> => {
  await http.post(`/v1/me/invitations/${id}/decline`)
}
